import { Component, OnInit, Input } from '@angular/core';
import { LoyaltyService } from '../loyalty.service';
import { interval } from 'rxjs';

@Component({
  selector: 'pv-loyalty',
  templateUrl: './loyalty.component.html',
  styleUrls: ['./loyalty.component.scss']
})
export class LoyaltyComponent implements OnInit {
  @Input() showLink;
  @Input() short;
  @Input() long;
  @Input() toolbar;
  total = 0;
  remaining = 0;
  level = 0;
  loading = false;

  constructor(
    private loyaltyService: LoyaltyService
  ) { }

  ngOnInit() {
    this.total = this.loyaltyService.loyaltyPoints.total;
    this.level = this.loyaltyService.loyaltyPoints.level;
    this.remaining = this.loyaltyService.loyaltyPoints.remaining;


    this.loyaltyService.loyaltySubject
    .subscribe(({ remaining, total, level }) => {
      this.total = total;
      this.level = level;
      this.remaining = remaining;
    })

    this.getLoyaltyPoints()
  }

  getLoyaltyPoints() {
    this.loyaltyService.getLoyaltyPoints()
  }

}